// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"b15f978b","284":"b22cdb8b"}[chunkId] + ".chunk.js";
};